import type { HpbPageList_HpbPageListPageQuery } from "@/lib/gql/__generated__/graphql";
import { HpbPageType } from "@/lib/gql/__generated__/graphql";

import { useHpbPageDeleteMutation } from "../../repository/mutation/use-snack-delete-mutation";

type Props = {
	hotelID: string;
	data: HpbPageList_HpbPageListPageQuery;
};

export const useInit = ({ hotelID, data }: Props) => {
	const TOPPageItem = data.hpbPageList.pages.find(
		(page) => page.staticPageType && page.staticPageType === HpbPageType.Top,
	);
	const ordinaryPageList = data.hpbPageList.pages.filter((page) => page.staticPageType === null);

	const { onDelete } = useHpbPageDeleteMutation({ hotelID });

	return {
		TOPPageItem,
		ordinaryPageList,
		onDelete,
	};
};
